var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g({staticClass:"modal-close-button",attrs:{"md-icon":"close","flat":"","icon":"","fab":"","small":"","color":_vm.color,"text-color":"black","disabled":_vm.disabled}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }